import React, { FormEvent, useState } from "react";
import { connect } from "react-redux";
import { Card, Checkbox, CheckboxProps, Container, Form, Grid, Modal, Radio } from "semantic-ui-react";
import { Profil } from "../../../model/entities/profil";
import passwordValidator from "password-validator";
import { userService } from "../../../services/authentication-redux-service";
import { ApplicationState } from "../../../store";
import { LOGIN_FAILURE, LOGIN_SUCCESSFUL, LOGOUT, REQUEST_IDENTITY, REQUEST_LOGIN } from "../../../store/authentication/types";
import { OAuthResponse } from "../../../model/authentication/oauth-response";
import { UserInfoResponse } from "../../../model/dto/response";
import { RegisterBody } from "../../../model/dto/body/register-body";
import { SubscriptionInvestisseurForm } from "../subscription-Investisseur-form";
import { SubscriptionCollectiviteForm } from "../subscription-collectivite-form";
import { SubmitButton } from "../../generic/submit-button";
import { InputField } from "../../generic/input-field";
import { useNavigate } from "react-router-dom";

type FieldData = {
  value?: any,
  name?: string,
  isValid?: boolean
};

type FormData = {
  newAdresseMail: FieldData,
  newPassword: FieldData,
  confirmationPsw: FieldData,
  cgu:FieldData,
  newType: FieldData,
  isMarketingMailsAllowed?: FieldData
}
 
function SignUp({ dispatchProps }: any) {
  const [form, setForm] = useState<FormData>({
    newAdresseMail : { name : "newAdresseMail", value : "", isValid: true},
    newPassword : { name : "newPassword", value : "", isValid: true},
    confirmationPsw : { name : "confirmationPsw", value : "", isValid: true},
    cgu : { name : "cgu", value : "", isValid: false},
    newType : {name : "newType", value : undefined, isValid: true},
    isMarketingMailsAllowed: {name: "isMarketingMailsAllowed", value: "false", isValid: true}
  })

  const [displayDisclaimer, setDisplayDisclaimer] = useState(false)
  const [loginError, setLoginError] = useState("")
  const [signupError, setSignupError] = useState("")
  const [newUsername, setNewUsername] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [isFormError, setIsFormError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [mailError, setMailError] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmationPassword, setShowConfirmationPassword] = useState(false)
  const [isOnboardingModalOpen, setIsOnboardingModalOpen] = useState(false)

  const navigate = useNavigate();

  function loginUser(username: string, password: string, verifyIdentityStep = false, directLogin = false) {
    userService
      .login2(username, password)
      .then((response) => {
        if (response.status !== 200) {
          dispatchProps.loginFailure?.();
          throw new Error();
        }
        return response.json();
      })
      .then((user: OAuthResponse) => {
        localStorage.setItem("oauth_user", JSON.stringify(user));
        if (user.error) {
          dispatchProps.loginFailure?.();
          throw new Error();
        }
        dispatchProps.loginSuccessful?.(user);
        if(!verifyIdentityStep) {
          userService
          .getUserInfo(user.userId, user)
          .then((response) => {
            localStorage.setItem("user_info", JSON.stringify(response));
            dispatchProps.requestIdentity?.(response);
            if(directLogin) {
              if(user.profilCode === Profil.INVESTISSEUR) {
                window.location.href = "/dashboard/citoyen"
              }
              else if (user.profilCode === Profil.PORTEUR_PROJET) {
                window.location.href = "dashboard/collectivite"
              }
              else if (user.profilCode === Profil.VILLYZ_USER) {
                window.location.href = "dashboard/admin"
              }
            }
          });
        }
        else {
          if(directLogin) {
            if(user.profilCode === Profil.INVESTISSEUR) {
              window.location.href = "/dashboard/citoyen"
            }
            else if (user.profilCode === Profil.PORTEUR_PROJET) {
              window.location.href = "dashboard/collectivite"
            }
            else if (user.profilCode === Profil.VILLYZ_USER) {
              window.location.href = "dashboard/admin"
            }
          }
        }
      })
    .catch(() =>
      setLoginError(
        "Impossible de se connecter. Vérifiez votre adresse mail et mot de passe"
      )
    );  
  }

  function isFormValid() : boolean {
    const regex = /^[\w.+-]{1,64}@([a-zA-Z\d-]{2,252}\.[a-zA-Z\.]{2,7})$/
    if(!regex.test(form.newAdresseMail.value)) {
      setMailError(true)
      return false
    }
    if (!validatePassword(form.newPassword.value)) {
      setSignupError(
        "Votre mot de passe doit faire au moins 8 caractères et contenir au moins  une majuscule, une minuscule et un chiffre.​"
      );
      return false;
    }
    if (!form.cgu.isValid) {
      setSignupError("Vous devez accepter les conditions d'utilisation");
      return false
    }
    if (!form.newType.value) {
      setSignupError("Vous devez saisir un profil d'utilisateur");
      return false
    }
    if (form.newPassword.value !== form.confirmationPsw.value) {
      setSignupError("Les mots de passe ne correspondent pas");
      return false
    }
    return true;
  }

  function handleCheckBoxChange(event: FormEvent<HTMLInputElement>, data: CheckboxProps){
    const fieldName = data.name
    let value = false
    if(data.value === "ok") {
      value = true
    }
    const newField: FieldData = { [fieldName!]: { value: value, name: fieldName, isValid: data.checked } };
  
    setForm({ ...form,  ...newField});
    setIsFormError(false);
    setSignupError("");
  }

  function onSubmitSuccess(response:Response){
    setNewUsername(form.newAdresseMail.value)
    setNewPassword(form.newPassword.value)
    loginUser(form.newAdresseMail.value, form.newPassword.value, false, false)
    setIsOnboardingModalOpen(true)
  }

  function onSubmitFailed(response : any){
    if(response.Error){
      setSignupError(response.Error);
    } else {
      setSignupError(
        "Erreur lors de l'inscription. Vérifiez que vous avez correctement saisi tous les champs."
      );
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const fieldValue: string = e.target.value;
    const fieldName = e.target.name;
    const newField: FieldData = { [fieldName!]: { value: fieldValue, name: fieldName, isValid: true } };
  
    setForm({ ...form,  ...newField});
    setIsFormError(false)
    setSignupError("")
  }

  const handleMailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setMailError(false)
    handleInputChange(e)
  }

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value: string = e.target.value;
    const isValid = validatePassword(value) as boolean
    setPasswordError(!isValid)
    handleInputChange(e)
  }

  const hideShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const hideShowConfirmationPassword = () => {
    setShowConfirmationPassword(!showConfirmationPassword);
  };

  const body : RegisterBody = {
    Email : form.newAdresseMail.value,
    Password : form.newPassword.value,
    ConfirmPassword : form.confirmationPsw.value,
    ProfilCode : form.newType.value,
    IsMarketingMailsAllowed: form.isMarketingMailsAllowed?.value
  }

  return (
    <div className="pt-12" style={{fontFamily: "raleway"}}>
      <Container>
        <Grid stackable columns={2}>
          <Grid.Column>
            <div style={{paddingLeft: "55px", color: '#000'}}>
              <h1 style={{fontSize: '38px', fontFamily:"merriweather", fontWeight: 700}}>Investissez votre territoire</h1>
              <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.98 5.40313C15.1323 5.64673 15.235 5.91794 15.2825 6.20126C15.3299 6.48458 15.3211 6.77448 15.2565 7.05439C15.1919 7.3343 15.0728 7.59875 14.906 7.83263C14.7392 8.06651 14.528 8.26525 14.2844 8.41751C11.6206 10.0742 9.50514 12.4804 8.20312 15.3344C9.51975 15.2243 10.839 15.5142 11.9881 16.1661C13.1373 16.818 14.063 17.8016 14.6439 18.9883C15.2249 20.1749 15.4342 21.5093 15.2444 22.8168C15.0546 24.1243 14.4746 25.3441 13.5802 26.3165C12.6858 27.289 11.5187 27.9688 10.2316 28.2671C8.94446 28.5654 7.59728 28.4682 6.3663 27.9883C5.13532 27.5084 4.07786 26.6681 3.33227 25.5774C2.58668 24.4866 2.18769 23.1962 2.1875 21.875V21.8159C2.18921 21.6466 2.19651 21.4773 2.20937 21.3084C2.22906 20.9803 2.26844 20.5209 2.345 19.9566C2.49813 18.8344 2.79781 17.2878 3.40375 15.5509C4.61125 12.0728 7.05687 7.77438 11.9656 4.70751C12.2092 4.55525 12.4804 4.45247 12.7638 4.40503C13.0471 4.35759 13.337 4.36642 13.6169 4.43102C13.8968 4.49561 14.1612 4.61471 14.3951 4.7815C14.629 4.9483 14.8277 5.15953 14.98 5.40313ZM30.2925 5.40313C30.4447 5.64673 30.5475 5.91794 30.595 6.20126C30.6424 6.48458 30.6336 6.77448 30.569 7.05439C30.5044 7.3343 30.3853 7.59875 30.2185 7.83263C30.0517 8.06651 29.8405 8.26525 29.5969 8.41751C26.933 10.0741 24.8175 12.4803 23.5156 15.3344C24.8323 15.2243 26.1515 15.5142 27.3006 16.1661C28.4498 16.818 29.3755 17.8016 29.9564 18.9883C30.5374 20.1749 30.7467 21.5093 30.5569 22.8168C30.3671 24.1243 29.7871 25.3441 28.8927 26.3165C27.9983 27.289 26.8312 27.9688 25.5441 28.2671C24.257 28.5654 22.9098 28.4682 21.6788 27.9883C20.4478 27.5084 19.3904 26.6681 18.6448 25.5774C17.8992 24.4866 17.5002 23.1962 17.5 21.875V21.8159C17.5017 21.6466 17.509 21.4773 17.5219 21.3084C17.5416 20.9803 17.5809 20.5209 17.6575 19.9566C17.8106 18.8344 18.1103 17.2878 18.7162 15.5509C19.9237 12.0728 22.3694 7.77438 27.2781 4.70751C27.5217 4.55525 27.7929 4.45247 28.0763 4.40503C28.3596 4.35759 28.6495 4.36642 28.9294 4.43102C29.2093 4.49561 29.4737 4.61471 29.7076 4.7815C29.9415 4.9483 30.1402 5.15953 30.2925 5.40313Z" fill="#005877"/>
              </svg>
              <p style={{fontSize: '18px'}}>Nos investissements ont un impact sur notre avenir, aussi le concept d’investissement citoyen est un excellent moyen de s’impliquer.</p>
              <p style={{fontSize: '18px'}}>Laurence Q.</p>
            </div>
          </Grid.Column>
          <Grid.Column>
            <div style={{padding: "0px 55px", color: '#000'}}>
              <h1 css={{fontSize: '38px', fontWeight: 400, color: "#085c74", fontFamily:"merriweather"}}>Inscription</h1>
              <Card fluid>
                <Card.Content>
                  <Form>
                    <Form.Field>
                      <Radio
                        label="Je suis un investisseur"
                        name="type"
                        value={Profil.INVESTISSEUR}
                        checked={form.newType.value === Profil.INVESTISSEUR}
                        onClick={() => setForm({...form, newType : {name : "newType", value : Profil.INVESTISSEUR, isValid : true}})}
                      />
                    </Form.Field>
                    <Form.Field>
                      <Radio
                        label="Je suis un porteur de projet"
                        name="type"
                        value={Profil.PORTEUR_PROJET}
                        checked={form.newType.value === Profil.PORTEUR_PROJET}
                        onClick={() => setForm({...form, newType : {name : "newType", value : Profil.PORTEUR_PROJET, isValid : true}})}
                      />
                    </Form.Field>
                    <Form.Field>
                      <InputField 
                        data={form.newAdresseMail}
                        label="Adresse mail"
                        onChange={handleMailChange}   
                        type="email"
                        autocomplete="email"
                        required={true}                
                      />
                      {mailError && <p className="text-red-600">Votre adresse mail présente une erreur de format.</p>}
                    </Form.Field>
                    <Form.Field>
                      <InputField 
                        data={form.newPassword} 
                        label="Mot de passe"
                        onChange={handlePasswordChange} 
                        required={true}   
                        autocomplete="new-password" 
                        type={showPassword ? "text" : "password"}   
                        icon={ 
                          <button onClick={hideShowPassword}>
                            {showPassword ? (
                              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 11.5C9.10998 11.5 8.23995 11.2361 7.49993 10.7416C6.75991 10.2471 6.18314 9.54434 5.84254 8.72208C5.50195 7.89981 5.41283 6.99501 5.58647 6.12209C5.7601 5.24918 6.18868 4.44736 6.81802 3.81802C7.44736 3.18868 8.24918 2.7601 9.12209 2.58647C9.99501 2.41283 10.8998 2.50195 11.7221 2.84254C12.5443 3.18314 13.2471 3.75991 13.7416 4.49993C14.2361 5.23996 14.5 6.10998 14.5 7C14.5 8.19348 14.0259 9.33807 13.182 10.182C12.3381 11.0259 11.1935 11.5 10 11.5ZM10 0C3 0 0 7 0 7C0 7 3 14 10 14C17 14 20 7 20 7C20 7 17 0 10 0Z" fill="#979797"/>
                              </svg>
                            ) : (
                              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.24891 0.280712C3.06031 0.0985537 2.80771 -0.00224062 2.54551 3.78026e-05C2.28331 0.00231622 2.0325 0.107485 1.84709 0.292893C1.66168 0.478301 1.55652 0.729114 1.55424 0.991311C1.55196 1.25351 1.65275 1.50611 1.83491 1.69471L15.8349 15.6947C16.0235 15.8769 16.2761 15.9777 16.5383 15.9754C16.8005 15.9731 17.0513 15.8679 17.2367 15.6825C17.4221 15.4971 17.5273 15.2463 17.5296 14.9841C17.5319 14.7219 17.4311 14.4693 17.2489 14.2807L15.7759 12.8077C17.3334 11.5658 18.4852 9.88764 19.0839 7.98771C17.8099 3.93071 14.0199 0.987712 9.54191 0.987712C7.97434 0.985586 6.42841 1.35357 5.02991 2.06171L3.24891 0.280712ZM7.50991 4.54071L9.02391 6.05571C9.363 5.96566 9.7198 5.96626 10.0586 6.05744C10.3974 6.14862 10.7063 6.32719 10.9543 6.57528C11.2024 6.82336 11.381 7.13226 11.4722 7.47104C11.5634 7.80983 11.564 8.16662 11.4739 8.50571L12.9879 10.0197C13.4389 9.25573 13.6231 8.36351 13.5116 7.48339C13.4 6.60327 12.9991 5.78521 12.3717 5.15789C11.7444 4.53057 10.9264 4.12961 10.0462 4.01806C9.16612 3.90652 8.27389 4.08973 7.50991 4.54071Z" fill="#979797"/>
                              <path d="M11.996 14.6849L9.292 11.9799C8.31969 11.919 7.40303 11.5053 6.71406 10.8165C6.02509 10.1278 5.61117 9.21122 5.55 8.23892L1.877 4.56592C1.03221 5.57193 0.394349 6.73483 0 7.98792C1.274 12.0449 5.065 14.9879 9.542 14.9879C10.389 14.9879 11.211 14.8829 11.996 14.6849Z" fill="#979797"/>
                              </svg>
                            )}
                          </button>
                        }    
                      />
                      {passwordError && <p className="text-red-600">Votre mot de passe doit faire au moins 8 caractères et contenir au moins  une majuscule, une minuscule et un chiffre.</p>}
                    </Form.Field>
                    <Form.Field>
                      <InputField 
                        data={form.confirmationPsw}
                        label="Confirmer le mot de passe"
                        autocomplete="new-password"
                        required={true}  
                        onChange={handleInputChange}  
                        type={showConfirmationPassword ? "text" : "password"}   
                        icon={ 
                          <div onClick={hideShowConfirmationPassword}>
                            {showConfirmationPassword ? (
                              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10 11.5C9.10998 11.5 8.23995 11.2361 7.49993 10.7416C6.75991 10.2471 6.18314 9.54434 5.84254 8.72208C5.50195 7.89981 5.41283 6.99501 5.58647 6.12209C5.7601 5.24918 6.18868 4.44736 6.81802 3.81802C7.44736 3.18868 8.24918 2.7601 9.12209 2.58647C9.99501 2.41283 10.8998 2.50195 11.7221 2.84254C12.5443 3.18314 13.2471 3.75991 13.7416 4.49993C14.2361 5.23996 14.5 6.10998 14.5 7C14.5 8.19348 14.0259 9.33807 13.182 10.182C12.3381 11.0259 11.1935 11.5 10 11.5ZM10 0C3 0 0 7 0 7C0 7 3 14 10 14C17 14 20 7 20 7C20 7 17 0 10 0Z" fill="#979797"/>
                              </svg>
                            ) : (
                              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.24891 0.280712C3.06031 0.0985537 2.80771 -0.00224062 2.54551 3.78026e-05C2.28331 0.00231622 2.0325 0.107485 1.84709 0.292893C1.66168 0.478301 1.55652 0.729114 1.55424 0.991311C1.55196 1.25351 1.65275 1.50611 1.83491 1.69471L15.8349 15.6947C16.0235 15.8769 16.2761 15.9777 16.5383 15.9754C16.8005 15.9731 17.0513 15.8679 17.2367 15.6825C17.4221 15.4971 17.5273 15.2463 17.5296 14.9841C17.5319 14.7219 17.4311 14.4693 17.2489 14.2807L15.7759 12.8077C17.3334 11.5658 18.4852 9.88764 19.0839 7.98771C17.8099 3.93071 14.0199 0.987712 9.54191 0.987712C7.97434 0.985586 6.42841 1.35357 5.02991 2.06171L3.24891 0.280712ZM7.50991 4.54071L9.02391 6.05571C9.363 5.96566 9.7198 5.96626 10.0586 6.05744C10.3974 6.14862 10.7063 6.32719 10.9543 6.57528C11.2024 6.82336 11.381 7.13226 11.4722 7.47104C11.5634 7.80983 11.564 8.16662 11.4739 8.50571L12.9879 10.0197C13.4389 9.25573 13.6231 8.36351 13.5116 7.48339C13.4 6.60327 12.9991 5.78521 12.3717 5.15789C11.7444 4.53057 10.9264 4.12961 10.0462 4.01806C9.16612 3.90652 8.27389 4.08973 7.50991 4.54071Z" fill="#979797"/>
                              <path d="M11.996 14.6849L9.292 11.9799C8.31969 11.919 7.40303 11.5053 6.71406 10.8165C6.02509 10.1278 5.61117 9.21122 5.55 8.23892L1.877 4.56592C1.03221 5.57193 0.394349 6.73483 0 7.98792C1.274 12.0449 5.065 14.9879 9.542 14.9879C10.389 14.9879 11.211 14.8829 11.996 14.6849Z" fill="#979797"/>
                              </svg>
                            )}
                          </div>
                        }         
                      />
                    </Form.Field>
                    <Form.Field>
                      <Checkbox
                        required
                        name="cgu"
                        value="ok"
                        label= 
                          {<label>
                            <div onClick={(event)=>{ event.stopPropagation() }}>
                              <p css={{color: '#000 !important'}}>Je reconnais avoir pris connaissance et accepté les :</p>
                              <p>
                                <a 
                                  href="https://storage.gra.cloud.ovh.net/v1/AUTH_36f6e4b864bd4af78a6b90757af4090b/villyz_assets/cgu.pdf" 
                                  target="_blank"
                                >
                                  Conditions d’utilisation de Villyz 
                                </a>
                              </p>
                              <p>
                                <a
                                  href="https://www.mangopay.com/terms/PSP/PSP_MANGOPAY_FR.pdf"
                                  target="_blank"
                                >
                                  Conditions d’utilisation de Mangopay
                                </a>
                              </p>
                            </div>
                          </label>}
                        onChange={handleCheckBoxChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <Checkbox
                        name="isMarketingMailsAllowed"
                        value="ok"
                        label={
                          <label css={{color: '#000 !important'}}><span
                            onClick={(event)=>{event.stopPropagation()}}>
                            J’accepte de recevoir des informations liées aux projets publiés ainsi qu’à l’activité de la plateforme.
                          </span></label>
                          }
                        onChange={handleCheckBoxChange}
                      />
                    </Form.Field>
                    {displayDisclaimer && (
                      <p className="text-sm">
                        Vous pouvez exercer vos droits d’accès, de rectification
                        et de suppression à l’adresse postale et/ou électronique
                        suivantes : rgpd@villyz.fr DPO 35 avenue
                        Reille, 75014 Paris
                      </p>
                    )}
                    <div style={{ display: "flex", justifyContent: "center"}}>
                      <SubmitButton 
                        label = "Poursuivre l’inscription"
                        action = {() => userService.registerNewAccount(body)}
                        onActionSuccess = {onSubmitSuccess}
                        validateForm = {isFormValid}
                        onActionFailure = {onSubmitFailed}
                        style={{fontFamily: "raleway", fontWeight: '700'}}
                        icon='/img/icons/fleche.svg'
                      />
                    </div>
                    <div 
                      style={{
                        cursor: 'pointer', 
                        textDecoration: 'underline', 
                        textAlign: 'center', 
                        marginTop:'8px', 
                        fontSize: '16px',
                        color: '#000'
                      }}
                      onClick={() => { navigate("/connexion")}}
                    >
                      Se connecter
                    </div>
                    {signupError && <p className="text-red-600">{signupError}</p>}
                  </Form>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        </Grid>

        <Modal
          onClose={() => setIsOnboardingModalOpen(false)}
          open={isOnboardingModalOpen}
          closeOnDocumentClick={false}
          closeOnEscape={false}
          closeOnPortalMouseLeave={false}
          closeOnDimmerClick={false}
        >
          <Modal.Header>Inscription</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div style={{overflowX: 'hidden'}}>
                {form.newType.value === Profil.INVESTISSEUR ? (
                  <SubscriptionInvestisseurForm
                    onFinishOnboarding={() => loginUser(newUsername, newPassword)}
                  />
                ) 
                : 
                form.newType.value === Profil.PORTEUR_PROJET ? (
                  <SubscriptionCollectiviteForm
                    onSubmitIdentificationSuccess={() => loginUser(newUsername, newPassword, false)}
                    onFinishOnboarding={() => loginUser(newUsername, newPassword)}
                  />
                ) 
                : 
                (
                  <div></div>
                )}
              </div>
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </Container>
    </div>
  );
}

const mapStateToProps = (state: ApplicationState) => ({
  loginProps: state.authentication,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchProps: {
    loginRequest: () => dispatch({ type: REQUEST_LOGIN }),
    loginSuccessful: (authResponse: OAuthResponse) =>
      dispatch({ type: LOGIN_SUCCESSFUL, authResponse: authResponse }),
    loginFailure: () => dispatch({ type: LOGIN_FAILURE }),
    logOut: () => dispatch({ type: LOGOUT }),
    requestIdentity: (userInfo: UserInfoResponse) =>
      dispatch({ type: REQUEST_IDENTITY, user: userInfo }),
  },
});

const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(SignUp);
export { ConnectedLogin as SignUp };

const pwdSchema = new passwordValidator();
pwdSchema
  .is()
  .min(8)
  .is()
  .max(50)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits(1)
  .has()
  .not()
  .spaces();

function validatePassword(password: string) {
  return pwdSchema.validate(password)
}
